export const vulcan_hoodie = {
  msrp: 59.99,
  infoLink: 'https://www.teamtriton.com/vulcan-custom-sublimated-hoodie.html',
  items: [
    {
      number: 'VH98',
      hasModel: false,
    },
    {
      number: 'VH99',
      hasModel: false,
    },
    {
      number: 'VH100',
      hasModel: false,
    },
    {
      number: 'VH101',
      hasModel: false,
    },
    {
      number: 'VH102',
      hasModel: false,
    },
    {
      number: 'VH103',
      hasModel: false,
    },
    {
      number: 'VH104',
      hasModel: false,
    },
    {
      number: 'VH105',
      hasModel: false,
    },
    {
      number: 'VH106',
      hasModel: false,
    },
    {
      number: 'VH107',
      hasModel: false,
    },
    {
      number: 'VH108',
      hasModel: false,
    },
    {
      number: 'VH109',
      hasModel: false,
    },
    {
      number: 'VH110',
      hasModel: false,
    },
    {
      number: 'VH111',
      hasModel: false,
    },
    {
      number: 'VH112',
      hasModel: false,
    },
    {
      number: 'VH113',
      hasModel: false,
    },
    {
      number: 'VH114',
      hasModel: false,
    },
    {
      number: 'VH115',
      hasModel: false,
    },
    {
      number: 'VH116',
      hasModel: false,
    },
    {
      number: 'VH117',
      hasModel: false,
    },
    {
      number: 'VH118',
      hasModel: false,
    },
    {
      number: 'VH119',
      hasModel: false,
    },
    {
      number: 'VH120',
      hasModel: false,
    },
    {
      number: 'VH121',
      hasModel: false,
    },
    {
      number: 'VH122',
      hasModel: false,
    },
    {
      number: 'VH123',
      hasModel: false,
    },
    {
      number: 'VH124',
      hasModel: false,
    },
  ],
};
